/* eslint react-hooks/exhaustive-deps: 0 */
import { useContext, useState, useEffect } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";

const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [ price, setPrice ] = useState(items.length === 1 && items[0]?.priceInfo?.price ? formatter.format(items[0]?.priceInfo?.price) : '')
  const [ retailPrice, setRetailPrice ] = useState(items.length === 1 && items[0]?.priceInfo?.retailPrice ? formatter.format(items[0]?.priceInfo?.retailPrice) : '')
  const [ markup, setMarkup ] = useState(items.length === 1 && items[0]?.priceInfo?.markup ? items[0]?.priceInfo?.markup : '')
  
  const { account, selectedStore, updateItem, exchangeRates, storeCurrency } = useContext(AuthContext);
  let retailCurrency = items[0]?.priceInfo?.retailPriceCurrency || storeCurrency
  let costCurrency = items[0]?.priceInfo?.currency || storeCurrency
  const retailCurrencyToCostCurrencyRate = exchangeRates[retailCurrency].rate / exchangeRates[costCurrency].rate

  useEffect(() => {
    if (price && retailPrice && !markup) {
      let newMarkup = retailPrice / price / retailCurrencyToCostCurrencyRate
      setMarkup(formatter.format(newMarkup))
    }
  }, [])

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  const handleSave = () => {
    let bulk_update = []

    Tracking.track('Portal - Bulk edit Price Info', { items: items.length })

    items.forEach((item) => {
      bulk_update.push(new Promise((resolve, reject) => {
        updateItem(
          item,
          {
            priceInfo: {
              price: parseFloat(price),
              retailPrice: parseFloat(retailPrice),
              currency: account.acctStores[selectedStore].currency,
              retailPriceCurrency: account.acctStores[selectedStore].currency,
              markup: parseFloat(markup),
              quantity: item.priceInfo?.quantity || 0
            }
          },
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>Set All Pricing</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set All Pricing</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change pricing details of all of your selected items
          </DialogContentText>
          {/*  */}
          <Grid container spacing={1} sx={{ marginTop: 1 }}>
            <Grid item xs={4}>
              <TextField
                InputLabelProps={{ shrink: true }}
                variant='standard'
                label={`Cost (${costCurrency})`}
                value={price}
                onChange={(e) => {
                  let newPrice = e.target.value
                  setPrice(newPrice.replace(/[a-zA-Z\,]/, '.'))
                  if (markup && markup !== 0) {
                    let newRetailPrice = newPrice * retailCurrencyToCostCurrencyRate * markup
                    if (!isNaN(newRetailPrice) && newRetailPrice !== 0) {
                      setRetailPrice(formatter.format(newRetailPrice))
                    }
                  }
                }}
                onBlur={() => {
                  if ((!markup || markup === 0) && retailPrice && price) {
                    let newMarkup = retailPrice / price / retailCurrencyToCostCurrencyRate
                    if (!isNaN(newMarkup) && newMarkup !== 0) {
                      setMarkup(formatter.format(newMarkup))
                    }
                  }
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                InputLabelProps={{ shrink: true }}
                variant='standard'
                label={`Retail Price (${retailCurrency})`}
                value={retailPrice}
                onChange={(e) => { 
                  let newRetailPrice = e.target.value
                  setRetailPrice(newRetailPrice.replace(/[a-zA-Z\,]/, '.'))
                  if (price) {
                    let newMarkup = newRetailPrice / price / retailCurrencyToCostCurrencyRate
                    if (!isNaN(newMarkup) && newMarkup !== 0) {
                      setMarkup(formatter.format(newMarkup))
                    }
                  }
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                InputLabelProps={{ shrink: true }}
                variant='standard'
                label="Markup"
                value={markup}
                onChange={(e) => {
                  let newMarkup = e.target.value
                  setMarkup(newMarkup.replace(/[a-zA-Z\,]/, '.'))
                  if (price && newMarkup !== 0) {
                    let newRetailPrice = newMarkup * price * retailCurrencyToCostCurrencyRate
                    if (!isNaN(newRetailPrice) && newRetailPrice !== 0) {
                      setRetailPrice(formatter.format(newRetailPrice))
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}